<template>
  <div class="header">
    <div class="header-left">
      <div class="logo-wrapper">
        <Logo />
      </div>
      <div class="nav-wrapper">
        <NavMenu />
      </div>
    </div>
    <div class="header-right">
      <a-space :size="4">
        <ProjectMenu />
        <Feedback />
        <Mention />
        <AvatarMenu />
      </a-space>
    </div>
  </div>
</template>
<script>
import Logo from '@/layouts/components/Logo';
import AvatarMenu from '@/layouts/components/AvatarMenu';
import Feedback from '@/layouts/components/Feedback';
import Mention from '@/layouts/components/Mention';
import NavMenu from '@/layouts/components/NavMenu';
import ProjectMenu from '@/layouts/components/ProjectMenu';

export default {
  components: { AvatarMenu, NavMenu, Logo, Feedback, ProjectMenu, Mention }
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 4px;
  background-color: #fff;

  .header-left {
    display: flex;
    align-items: center;
    flex: 1;

    .logo-wrapper {
      margin-right: 24px;
    }

    .nav-wrapper {
      flex: 1;
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
}
</style>
